<template>
  <b-container>
    <LoadingIndicator 
      v-if="loading"
    />
    <div v-if="!loading">
      <b-row>
        <b-col>
          <BaseMessageBlock :type="'Warning'" :messages="warnings"></BaseMessageBlock>
        </b-col>
      </b-row>
      <ProjectDetails
        v-if="projectId"
        :projectName="`Welcome to ${projectName}`"
        :residentEngineer="ownerName"
        :projectManager="contractorName"
        :facilitatorName="facilitatorName"
        :organizationLogo="ownerLogo"
        :contractorLogo="contractorLogo"
      />
      <b-row>
        <b-col></b-col>
        <b-col cols="auto" style="width: 400px;" class="widget p-4 mt-5">
          <h2>Account Setup</h2>
          <b-row>
            <b-col>
              <b-form v-if="showForm" @submit.prevent="setupAccount">
                <b-form-group label="Email" label-for="email">
                  <b-form-input id="email" v-model="email" maxlength="254" disabled></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Name"
                  label-for="name"
                  invalid-feedback="Please enter your name"
                >
                  <b-form-input
                    id="name"
                    v-model.trim="form.name"
                    maxlength="100"
                    :state="errors.length == 0 ? null :  form.name.length > 0"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Mobile Phone"
                  label-for="phone"
                  invalid-feedback="Please enter a valid phone number"
                >
                  <b-form-input
                    id="phone"
                    v-model="form.phone"
                    type="tel"
                    :state="errors.length == 0 ? null :  validPhone"
                    v-mask="'(###) ###-####'"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-row>
                  <b-col>
                    <b-form-group label="Allow Email notifications" label-for="email-notify">
                      <b-form-select
                        id="email-notify"
                        v-model="form.emailNotifications"
                        :state="true"
                      >
                        <b-form-select-option :value="true">Yes</b-form-select-option>
                        <b-form-select-option :value="false">No</b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Allow Mobile notifications" label-for="text-notify">
                      <b-form-select
                        id="text-notify"
                        v-model="form.textNotifications"
                        invalid-feedback="Please enter a valid phone number"
                        :state="errors.length == 0 ? null :  validTextNotifications"
                      >
                        <b-form-select-option :value="true">Yes</b-form-select-option>
                        <b-form-select-option :value="false">No</b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group v-if="projectId" label="Organization/Company" label-for="organization">
                  <b-form-select
                    id="organization"
                    v-model="form.organization"
                    class="w-100"
                    required
                  >
                    <b-form-select-option
                      v-for="(org,i) in organizations"
                      :key="`org-${i}`"
                      :value="org.id"
                    >{{org.name}}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  class="float-right ml-2"
                  :disabled="sending"
                >
                  <div v-if="!sending">Submit</div>
                  <b-spinner small v-if="sending" label="Spinning"></b-spinner>
                </b-button>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseMessageBlock :messages="errors"></BaseMessageBlock>
              <BaseMessageBlock :type="'Success'" :messages="messages"></BaseMessageBlock>
            </b-col>
          </b-row>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import authMixin from "@/mixins/auth-mixin.js";

import ProjectDetails from "@/components/project/ProjectDetails.vue";

export default {
  name: "AccountSetup",
  mixins: [authMixin],
  components: {
    ProjectDetails,
  },
  data() {
    return {
      errors: [],
      messages: [],
      warnings: [],
      sending: false,
      loading: false,
      showForm: false,
      form: {
        name: "",
        phone: "",
        textNotifications: true,
        emailNotifications: true,
        organization: null,
      },
      email: "",
      userId: "",
      organizations: [],
      surveyId: "",

      projectId: null,
      projectName: "",
      ownerName: "",
      ownerLogo: "",
      contractorName: "",
      contractorLogo: "",
      facilitatorName: "",
      surveyDay: "",
    };
  },
  mounted() {
    this.loading = true;
    let id = this.$route.query.uid;
    this.surveyId = this.$route.query.sid;
    this.projectId = localStorage.getItem("tempProjectId");
    if (!id) {
      this.errors.push({ message: "Missing User Id" });
      this.loading = false;
      return;
    }

    if (this.projectId) {
      // Get project details
      let url = `${this.$api_url}/projects/${this.projectId}/info`;
      axios.get(url, this.getReqConfig()).then((res) => {
        // console.log(res);
        this.projectName = res.data.projectName;
        this.ownerName = res.data.primaryOwnerName;
        this.ownerLogo = res.data.ownerLogo;
        this.contractorName = res.data.primaryContractorName;
        this.contractorLogo = res.data.contractorLogo;
        this.facilitatorName = res.data.facilitatorName;
        this.surveyDay = res.data.sendSurveyDay;
      });
    }

    if (!this.surveyId && this.$store.getters.getCurrentSurvey) {
      this.surveyId = this.$store.getters.getCurrentSurvey;
    }

    let url = `${this.$api_url}/users/${id}/account-setup-data`;
    if (this.projectId) {
      url += `?projectid=${this.projectId}`;
    }

    axios
      .get(
        url,
        this.getReqConfig()
      )
      .then((response) => {
        if (this.surveyId) {
          this.warnings.push({ message: "Your account isn't set up yet! Please create an account to see the survey results"})
        }
        this.userId = id;
        this.showForm = true;
        this.email = response.data.email;
        this.organizations = response.data.organizations;
        this.form.name = response.data.name;
        this.form.phone = response.data.phone;
      })
      .catch((err) => {
        if (this.authenticated) {
          this.defaultRedirect();
        } else {
          this.$router.push({
            name: "Login",
            query: { error: err.response.data[0] },
          });
        }
        //this.errors.push(err);
      })
      .finally(() => {
        this.loading = false;
      });
    
  },
  methods: {
    setupAccount() {
      if (!this.validateForm(this.form)) {
        return;
      }

      this.errors = [];
      this.sending = true;

      let request = {
        userId: this.userId,
        name: this.form.name,
        phone: this.form.phone,
        emailNotifications: this.form.emailNotifications,
        textNotifications: this.form.textNotifications,
        provider: this.provider,
      };

      if (this.projectId) {
        request.projectId = this.projectId;
        request.organizationId = this.form.organization;
      }

      let url = `${this.$api_url}/users/setup-account`;

      axios
        .post(url, request, this.getReqConfig())
        .then(() => {
          localStorage.removeItem('tempUserId')
          localStorage.removeItem('tempProjectId')

          if (this.$store.getters.getPauseAuth) {
            this.$store.dispatch("setPauseAuth", false);
            let user = this.accountUser;
            user.setup = true;
            this.$store.dispatch("setUser", user);
          }

          if (this.$store.getters.getCurrentSurvey){
            this.$store.dispatch('setCurrentSurvey', '');
          }

          //Do the redirects
          if (this.surveyId) {
            this.$router.push({
              name: "Login",
              query: {
                returnUrl: `/evaluation/${this.surveyId}/results`,
                message:
                  "Almost there! Please log in to see the survey results",
                autoLogin: true,
              },
            });
            return;
          }

          if (this.authenticated) {
            this.defaultRedirect(null, {
              signed_up: this.projectName,
              survey_day: this.surveyDay
            });
          } else {
            this.$router.push({
              name: "Login",
              query: {
                signed_up: this.projectName,
                autoLogin: true,
                survey_day: this.surveyDay
              },
            });
          }
        })
        .catch((err) => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        });
    },
    validateForm(form) {
      let errorCount = this.errors.length;

      if (form.name.length === 0) {
        this.errors.push({ message: "Name is empty" });
      }
      if (!form.textNotifications && !form.emailNotifications) {
        this.errors.push({
          message: "At least one notification method must be enabled",
        });
      }
      if (this.validPhone === false) {
        this.errors.push({ message: "Phone number is invalid" });
      }

      return errorCount == this.errors.length;
    },
  },
  computed: {
    validPhone() {
      return this.form.phone
        ? this.form.phone.replace(/[^0-9]/g, "").length === 10
        : false;
    },
    validTextNotifications() {
      return this.form.textNotifications ? this.validPhone !== false : true;
    },
    office365() {
      return this.$store.getters.getAuthProvider === "Microsoft";
    },
    provider() {
      return this.$store.getters.getAuthProvider === "Microsoft"
        ? "Microsoft"
        : "DashTech";
    },
  },
  watch: {
    accountUser(val) {
      if (this.office365 && val != null && val.setup === false) {
        this.$store.dispatch("setPauseAuth", true);
      }
    },
  },
};
</script>